import {
  INIT_AUTH_REQUEST_DATA,
  SET_AUTH_REQUEST_DATA,
  ERROR_AUTH_REQUEST_DATA,
  SET_AUTH_TOKEN,
  CLEAR_AUTH_TOKEN,
  SET_ROLE_TYPE,
  CLEAR_ROLE_TYPE
} from './action';

const initialState = {
  data: [],
  error: false,
  isLoading: false,
  token: null
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case INIT_AUTH_REQUEST_DATA:
      return {
        ...state,
        data: [],
        isLoading: true,
        error: false,
      };

    case SET_AUTH_REQUEST_DATA:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
        error: false,
      };

    case ERROR_AUTH_REQUEST_DATA:
      return {
        ...state,
        data: [],
        isLoading: false,
        error: action.payload,
      };

    case SET_AUTH_TOKEN:
      return {
        ...state,
        isLoading: false,
        token: action.payload,
      };

    case CLEAR_AUTH_TOKEN:
      return {
        ...state,
        token: null,
        data: [],
        isLoading: false,
        error: false,
      };

    case SET_ROLE_TYPE:
      return {
        ...state,
        isLoading: false,
        roleType: action.payload,
      };

    case CLEAR_ROLE_TYPE:
      return {
        ...state,
        isLoading: false,
        roleType: null,
      };

    default:
      return state;
  }
};

export default authReducer;
